jQuery(document).foundation();

(function($) {
  Hyphenator.run();
})( jQuery );
